module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_EN.20bc8415.txt";